// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #0d263f;
  --accent: #e72f44;
  --card: #ffffff;
  --muted: #f2f3f7;
  --text: #232137;
  --border: #e9ecf1;
}

* {
  box-sizing: border-box;
}

html, body, #root {
  height: 100%;
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  background: #f7f8fc;
  color: var(--text);
}

button {
  font: inherit;
}

a {
  color: inherit;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EAAI,sBAAA;AAEJ;;AADA;EAAoB,YAAA;AAKpB;;AAJA;EACE,SAAA;EACA,mEAAA;EACA,mBAAA;EACA,kBAAA;AAOF;;AAJA;EAAS,aAAA;AAQT;;AAPA;EAAI,cAAA;EAAgB,qBAAA;AAYpB","sourcesContent":[":root {\r\n  --bg: #0d263f;\r\n  --accent: #e72f44;\r\n  --card: #ffffff;\r\n  --muted: #f2f3f7;\r\n  --text: #232137;\r\n  --border: #e9ecf1;\r\n}\r\n\r\n* { box-sizing: border-box; }\r\nhtml, body, #root { height: 100%; }\r\nbody {\r\n  margin: 0;\r\n  font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\r\n  background: #f7f8fc;\r\n  color: var(--text);\r\n}\r\n\r\nbutton { font: inherit; }\r\na { color: inherit; text-decoration: none; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
